import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "shards-react";
import "./SectionTitle.css";

const SectionTitle = ({
  level = false,
  icon,
  primaryColor,
  tooltipId,
  tooltipContent,
  tooltipPlacement = "bottom",
  className = "",
  style,
  children,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const hasTooltip = tooltipId && tooltipContent;
  const Tag = level >= 1 && level <= 6 ? `h${level}` : "span";

  return (
    <Tag className={`hp-section-title ${className}`} style={style}>
      {icon && (
        <span
          className="hp-section-title__icon"
          style={{
            color: primaryColor,
            marginBottom: level < 3 ? 8 : level < 5 ? 5 : undefined,
          }}
        >
          {icon}
        </span>
      )}
      {children && (
        <span className="hp-section-title__text">
          {children}
          {hasTooltip && (
            <FontAwesomeIcon
              id={tooltipId}
              icon={faInfoCircle}
              className="hp-section-title__info-icon"
              style={{
                color: primaryColor,
              }}
            />
          )}
        </span>
      )}
      {hasTooltip && (
        <Tooltip
          target={`#${tooltipId}`}
          open={tooltipOpen}
          toggle={() => setTooltipOpen((o) => !o)}
          placement={tooltipPlacement}
          style={{
            backgroundColor: "white",
            border: `1px solid ${primaryColor}`,
          }}
          noArrow
          trigger={window.innerWidth <= 640 ? "click" : "hover"}
        >
          <span style={{ color: primaryColor }}>{tooltipContent}</span>
        </Tooltip>
      )}
    </Tag>
  );
};

export default SectionTitle;
